import React from 'react';
import { createModal } from '../../components/generic/Modal';
import { getParticipantBaseKey } from '../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { FileUploadModal } from './FileUploadModal';

interface Props {
  participantId: string;
  files?: File[];
}

export const ParticipantFileUploadModal = createModal<Props>((props) => {
  const { participantId, files, ...rest } = props;
  const { hide } = rest.modal;

  const { queryClient, organization, config } = useAppContext();
  const url = `${config.api.webUrl}/organizations/${organization.id}/participants/${participantId}/files`;

  const onUploaded = React.useCallback(
    (status: 'success' | 'error') => {
      const queryKey = getParticipantBaseKey({
        organizationId: organization.id,
        participantId,
      });

      queryClient.invalidateQueries(queryKey);

      if (status === 'success') {
        hide();
      }
    },
    [organization.id, participantId, queryClient, hide],
  );

  return <FileUploadModal url={url} onUploaded={onUploaded} files={files} {...rest} />;
});
